import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/layout/PrivateRoute';
import Layout from './components/layout/Layout';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import ClientList from './pages/clients/ClientList';
import ClientCreate from './pages/clients/ClientCreate';
import ClientDetail from './pages/clients/ClientDetail';
import ClientEdit from './pages/clients/ClientEdit';
import ActivityTypes from './pages/settings/ActivityTypes';
import Users from './pages/settings/Users';
import ProcedureTypes from './pages/settings/ProcedureTypes';
import SystemSettings from './pages/settings/SystemSettings';
import Profile from './pages/Profile';
import CaseFileList from './pages/casefiles/CaseFileList';
import CaseFileDetail from './pages/casefiles/CaseFileDetail';
import CaseFileCreate from './pages/casefiles/CaseFileCreate';
import BudgetList from './pages/budgets/BudgetList';
import BudgetCreate from './pages/budgets/BudgetCreate';
import BudgetDetail from './pages/budgets/BudgetDetail';
import NotarySettings from './pages/settings/NotarySettings';
import BudgetDocumentTypes from './pages/settings/BudgetDocumentTypes';
import UserManual from './pages/UserManual';
import AgendaCalendar from './pages/AgendaCalendar';
import AppointmentDetail from './pages/AppointmentDetail';
import AgendaStats from './pages/AgendaStats';
import AccountsReceivable from './pages/budgets/AccountsReceivable';
import NotaryDashboard from './pages/dashboard/NotaryDashboard';
import AuditLog from './pages/AuditLog';

const BodyClassManager = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/login') {
      document.body.className = 'form-membership';
    } else {
      document.body.className = '';
    }
  }, [location]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BodyClassManager />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />

          {/* Clientes */}
          <Route path="/clients" element={<PrivateRoute><Layout><ClientList /></Layout></PrivateRoute>} />
          <Route path="/clients/create" element={<PrivateRoute><Layout><ClientCreate /></Layout></PrivateRoute>} />
          <Route path="/clients/:id" element={<PrivateRoute><Layout><ClientDetail /></Layout></PrivateRoute>} />
          <Route path="/clients/:id/edit" element={<PrivateRoute><Layout><ClientEdit /></Layout></PrivateRoute>} />
          <Route path="/clients/:clientId/case-files/create" element={<PrivateRoute><Layout><CaseFileCreate /></Layout></PrivateRoute>} />

          {/* Expedientes */}
          <Route path="/case-files" element={<PrivateRoute><Layout><CaseFileList /></Layout></PrivateRoute>} />
          <Route path="/case-files/:id" element={<PrivateRoute><Layout><CaseFileDetail /></Layout></PrivateRoute>} />

          {/* Presupuestos */}
          <Route path="/budgets" element={<PrivateRoute><Layout><BudgetList /></Layout></PrivateRoute>} />
          <Route path="/budgets/create" element={<PrivateRoute><Layout><BudgetCreate /></Layout></PrivateRoute>} />
          <Route path="/budgets/:id" element={<PrivateRoute><Layout><BudgetDetail /></Layout></PrivateRoute>} />

          {/* Configuración */}
          <Route path="/settings/users" element={<PrivateRoute><Layout><Users /></Layout></PrivateRoute>} />
          <Route path="/settings/activity-types" element={<PrivateRoute><Layout><ActivityTypes /></Layout></PrivateRoute>} />
          <Route path="/settings/procedure-types" element={<PrivateRoute><Layout><ProcedureTypes /></Layout></PrivateRoute>} />
          <Route path="/settings/system" element={<PrivateRoute><Layout><SystemSettings /></Layout></PrivateRoute>} />
          <Route path="/settings/notary" element={<PrivateRoute><Layout><NotarySettings /></Layout></PrivateRoute>} />
          <Route path="/settings/budget-document-types" element={<PrivateRoute><Layout><BudgetDocumentTypes /></Layout></PrivateRoute>} />
          
            {/* Manual */}
          <Route path="/manual" element={<PrivateRoute><Layout><UserManual /></Layout></PrivateRoute>} />

          {/* Agenda */}
          <Route path="/agenda/stats" element={<PrivateRoute><Layout><AgendaStats /></Layout></PrivateRoute>} />
          <Route path="/agenda/:id" element={<PrivateRoute><Layout><AppointmentDetail /></Layout></PrivateRoute>} />
          <Route path="/agenda" element={<PrivateRoute><Layout><AgendaCalendar /></Layout></PrivateRoute>} />

          <Route path="/accounts-receivable" element={<PrivateRoute><Layout><AccountsReceivable /></Layout></PrivateRoute>} />
          <Route path="/notary-dashboard" element={<PrivateRoute><Layout><NotaryDashboard /></Layout></PrivateRoute>} />
          
          <Route path="/audit-log" element={<PrivateRoute><Layout><AuditLog /></Layout></PrivateRoute>} />

          <Route path="/profile" element={<PrivateRoute><Layout><Profile /></Layout></PrivateRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;